export default "__VITE_PUBLIC_ASSET__7eb31df1__"